import { ROUTES } from '../../pages/Home/const';

export const initialOption = { title: 'All', value: 'all' };

export const OPTIONS = [
  { title: 'Vacation', value: 'VAC' },
  { title: 'Administrative Leave', value: 'AL' },
  { title: 'Funeral Leave', value: 'BRV' },
  { title: 'Union Business', value: 'UNION' },
  { title: 'Department Business', value: 'DEPT' },
  { title: 'Sick (Self)', value: 'SICK_SELF' },
  { title: 'Sick (Family)', value: 'SICK_FAM' },
  { title: 'Leave with Pay', value: 'LWP' },
  { title: 'Leave without Pay', value: 'LWOP' },
  { title: 'Military Leave', value: 'MILITARY' },
  { title: 'Light Duty', value: 'LIGHT' },
  { title: 'Fill-in', value: 'SWAP' },
  { title: 'Injured', value: 'OJI' },
  { title: 'Reassignment', value: 'REASSIGN' },
  { title: 'Open Position', value: 'OPEN' },
  { title: 'Emergency Fill', value: 'Emergency' },
];

export const GROUPBY = [
  { title: 'Employee', value: 'Emp' },
  { title: 'Date', value: 'Date' },
];

export const REPORTS_INFO = {
  OVERTIME: {
    title: 'Overtime Report',
    id: 'overtime',
    link: ROUTES.REPORTS.OVERTIME_REPORT,
  },
  CALLBACK: {
    title: 'Callback Report',
    id: 'callback',
    link: ROUTES.REPORTS.CALLBACK_REPORT,
  },
  PTO: {
    title: 'PTO Report',
    id: 'pto',
    link: ROUTES.REPORTS.PTO_REPORT,
  },
  PAYROLL: {
    title: 'Payroll Report',
    id: 'payroll',
    link: ROUTES.REPORTS.PAYROLL_REPORT,
  },
  PAYROLL_SUMMARY: {
    title: 'Payroll Summary Report',
    id: 'payroll_summary',
    link: ROUTES.REPORTS.PAYROLL_SUMMARY_REPORT,
  },
  OVERTIME_LIST_MASTER: {
    title: 'Overtime List Master Report',
    id: 'overtime_list_master',
    link: ROUTES.REPORTS.OVERTIME_MASTER_REPORT,
  },
  MUNIS: {
    title: 'Munis Export Report',
    id: 'munis',
    link: ROUTES.REPORTS.MUNIS_REPORT,
  },
  WEEKLY_PAYROLL: {
    title: 'Complete Weekly Payroll Report',
    id: 'weekly_payroll',
    link: ROUTES.REPORTS.WEEKLY_PAYROLL_REPORT,
  },
  SHIFT_SWAPS: {
    title: 'Shift Swaps Report',
    id: 'swaps',
    link: ROUTES.REPORTS.SWAP_REPORT,
  },
  ADJUST_HOURS: {
    title: 'Adjust Hour Report',
    id: 'Adjust_Hours',
    link: ROUTES.REPORTS.ADJUST_HOURS_REPORT,
  },
  AVAILABILITY_DETAILT: {
    title: 'Availability Detail Report',
    id: 'availability_detail',
    link: ROUTES.REPORTS.AVAILABILITY_DETAIL_REPORT,
  },
  AVAILABILITY_SUMMARY: {
    title: 'Availability Summary Report',
    id: 'availability_summary',
    link: ROUTES.REPORTS.AVAILABILITY_SUMMARY_REPORT,
  },
  MILTON: {
    title: 'Milton Report',
    id: 'custom',
    link: ROUTES.REPORTS.MILTON_REPORT,
  },
  HOLIDAY: {
    title: 'Holiday Time Report',
    id: 'holiday',
    link: ROUTES.REPORTS.HOLIDAY_REPORT,
  },
  WOBURN_PAYBACK: {
    title: 'Woburn Payback Report',
    id: 'custom_payback',
    link: ROUTES.REPORTS.WOBURN_PAYBACK_REPORT,
  },
  WOBURN_OVERTIME: {
    title: 'Woburn Overtime Report',
    id: 'custom_ot',
    link: ROUTES.REPORTS.WOBURN_OVERTIME_REPORT,
  },
  WOBURN_REASSIGNMENT: {
    title: 'Woburn Reassignment Report',
    id: 'custom_acting',
    link: ROUTES.REPORTS.WOBURN_REASSIGNMENT_REPORT,
  },
  WOBURN_PTO: {
    title: 'Woburn PTO Report',
    id: 'custom_pto',
    link: ROUTES.REPORTS.WOBURN_PTO_REPORT,
  },
  WOBURN_MUNIS_PTO: {
    title: 'Woburn Munis PTO Report',
    id: 'custom_pto_munis',
    link: ROUTES.REPORTS.WOBURN_MUNIS_PTO_REPORT,
  },
  WOBURN_MUNIS_OVERTIME: {
    title: 'Woburn Munis Overtime Report',
    id: 'custom_ot_munis',
    link: ROUTES.REPORTS.WOBURN_MUNIS_OVERTIME_REPORT,
  },
  PTO_BALANCES: {
    title: 'PTO Balances Report',
    id: 'pto_balances',
    link: ROUTES.REPORTS.PTO_BALANCES,
  },
  WOBURN_PAYBACK: {
    title: 'Woburn Payback Report',
    id: 'custom_payback',
    link: ROUTES.REPORTS.WOBURN_PAYBACK_REPORT,
  },
  WOBURN_OVERTIME: {
    title: 'Woburn Overtime Report',
    id: 'custom_ot',
    link: ROUTES.REPORTS.WOBURN_OVERTIME_REPORT,
  },
  WOBURN_REASSIGNMENT: {
    title: 'Woburn Reassignment Report',
    id: 'custom_acting',
    link: ROUTES.REPORTS.WOBURN_REASSIGNMENT_REPORT,
  },
  WOBURN_PTO: {
    title: 'Woburn PTO Report',
    id: 'custom_pto',
    link: ROUTES.REPORTS.WOBURN_PTO_REPORT,
  },
  WOBURN_MUNIS_PTO: {
    title: 'Woburn Munis PTO Report',
    id: 'custom_pto_munis',
    link: ROUTES.REPORTS.WOBURN_MUNIS_PTO_REPORT,
  },
  WOBURN_MUNIS_OVERTIME: {
    title: 'Woburn Munis Overtime Report',
    id: 'custom_ot_munis',
    link: ROUTES.REPORTS.WOBURN_MUNIS_OVERTIME_REPORT,
  },
};

// Dev version
// We need to use this one on dev and staging
export const ALWAYS_PRESENT_REPORTS_MAP = [
  REPORTS_INFO.HOLIDAY,
  REPORTS_INFO.PTO_BALANCES,
];
// Prod version
// For now on prod we dont push PTO_BALANCES
// export const ALWAYS_PRESENT_REPORTS_MAP = [REPORTS_INFO.HOLIDAY];
